import { useState } from 'react';
import { ServiceRequestCreationNote } from './serviceRequestFormtypes';

export interface UseAddNoteSrFormStateReturn {
  isAddingNote: boolean;
  note: ServiceRequestCreationNote | null;
  hasNote: boolean;

  onStartAddingNote: () => void;
  onExitAddingNote: () => void;
  onSaveNote: (note: ServiceRequestCreationNote) => void;
  onRemoveNote: () => void;
}

export const useAddNoteSrFormState = (): UseAddNoteSrFormStateReturn => {
  const [isAddingNote, setIsAddingNote] = useState<boolean>(false);
  const [note, setNote] = useState<ServiceRequestCreationNote | null>(null);

  const hasNote: boolean = note !== null;

  const onStartAddingNote = (): void => {
    setIsAddingNote(true);
  };

  const onExitAddingNote = (): void => {
    setIsAddingNote(false);
  };

  const onSaveNote = (nextNote: ServiceRequestCreationNote): void => {
    setNote(nextNote);
    setIsAddingNote(false);
  };

  const onRemoveNote = (): void => {
    setNote(null);
    setIsAddingNote(false);
  };

  return {
    isAddingNote,
    note,
    hasNote,
    onStartAddingNote,
    onExitAddingNote,
    onSaveNote,
    onRemoveNote,
  };
};